import { ErrorViewModel }                       from '../../..';
import { EventBus,
         SessionEntity, 
         EmotionIdFromString,
         WidgetInjectionTypeEnum,
         IConversationSessionState }            from '../../..';

export interface IConversationSessionMutations {
  SET_BOT_PARAMS_REQUEST_IN_PROGRESS(state: IConversationSessionState): void;
  FETCH_BOT_PARAMS_REQUEST_ERROR(state: IConversationSessionState, error: ErrorViewModel): void;
  FETCH_SESSION_ID_REQUEST_IN_PROGRESS(state: IConversationSessionState): void;
  FETCH_SESSION_ID_REQUEST_ERROR(state: IConversationSessionState, error: ErrorViewModel): void;
  SET_CONFIG_PARAMS_AVAILABLE(state: IConversationSessionState): void;
  SET_INTEGRATION_MODE(state: IConversationSessionState, integrationMode: WidgetInjectionTypeEnum): void;
  SET_SUGGESTIONS_LIST(state: IConversationSessionState, suggestions: string[]): void;
  SET_NEW_SESSION_ID(state: IConversationSessionState, sessionInfo: SessionEntity): void;
  REMOVE_SESSION_ID(state: IConversationSessionState): void;
  SET_INIT_POST_REQUEST_IN_PROGRESS(state: IConversationSessionState): void;
  SET_INIT_POST_REQUEST_ERROR(state: IConversationSessionState, error: ErrorViewModel): void;
  TOGGLE_INTRODUCTION_SENTENCE_SHOWN(state: IConversationSessionState): void;
  UPDATE_NEXT_MESSAGE_WATERMARK(state: IConversationSessionState, watermark: number): void;
  UPDATE_SESSION_CONVERSATION_STATUS(state: IConversationSessionState, isOpen: boolean): void;
  UPDATE_EMOTION_TO_PLAY(state: IConversationSessionState, emotionToPlay: string): void;
  UPDATE_SESSION_SCORE(state: IConversationSessionState, score: number): void;
}

export const ConversationSessionMutations: IConversationSessionMutations = {
  SET_BOT_PARAMS_REQUEST_IN_PROGRESS: (state: IConversationSessionState) => {
    state.isLoading = true;
    state.error = undefined;
    state.isRequestSucceed = false;
  },

  FETCH_BOT_PARAMS_REQUEST_ERROR: (state: IConversationSessionState, error: ErrorViewModel) => {
    state.isLoading = false;
    state.error = error;
    state.isRequestSucceed = false;
  },

  FETCH_SESSION_ID_REQUEST_IN_PROGRESS: (state: IConversationSessionState) => {
    state.isLoading = true;
    state.error = undefined;
    state.isRequestSucceed = false;
  },

  FETCH_SESSION_ID_REQUEST_ERROR: (state: IConversationSessionState, error: ErrorViewModel) => {
    state.conversationSession = undefined;
    state.isLoading = false;
    state.error = error;
    state.isRequestSucceed = false;
  },

  SET_CONFIG_PARAMS_AVAILABLE: (state: IConversationSessionState) => {
    state.isWidgetConfigAvailable = 'true';
  },

  SET_INTEGRATION_MODE: (state: IConversationSessionState, integrationMode: WidgetInjectionTypeEnum) => {
    if (state.conversationSession) {
      state.conversationSession.integrationMode = integrationMode;
    }
  },

  SET_SUGGESTIONS_LIST: (state: IConversationSessionState, suggestions: string[]) => {
    state.suggestions = suggestions;
  },

  SET_NEW_SESSION_ID: (state: IConversationSessionState, sessionInfo: SessionEntity) => {
    state.isLoading = false;
    state.conversationSession = sessionInfo;
    state.error = undefined;
    state.isRequestSucceed = false;
  },

  REMOVE_SESSION_ID: (state: IConversationSessionState) => {
    state.conversationSession = undefined;
    state.isLoading = false;
    state.error = undefined;
    state.isRequestSucceed = true;
    state.emotionToPlayId = undefined;
  },

  SET_INIT_POST_REQUEST_IN_PROGRESS: (state: IConversationSessionState) => {
    state.isLoading = true;
    state.error = undefined;
    state.isRequestSucceed = false;
  },

  SET_INIT_POST_REQUEST_ERROR: (state: IConversationSessionState, error: ErrorViewModel) => {
    state.conversationSession = undefined;
    state.isLoading = false;
    state.error = error;
    state.isRequestSucceed = false;
  },

  TOGGLE_INTRODUCTION_SENTENCE_SHOWN: (state: IConversationSessionState) => {
    if (state.conversationSession) {
      state.conversationSession.isIntroductoryMsgShown = !state.conversationSession.isIntroductoryMsgShown;
    }
  },

  UPDATE_NEXT_MESSAGE_WATERMARK: (state: IConversationSessionState, watermark: number) => {
    state.isLoading = false;
    state.error = undefined;
    state.isRequestSucceed = true;
    if (state.conversationSession) {
      state.conversationSession.nextMsgWatermark = watermark;
    }
  },

  UPDATE_SESSION_CONVERSATION_STATUS: (state: IConversationSessionState, isOpen: boolean) => {
    state.isLoading = false;
    state.error = undefined;
    state.isRequestSucceed = true;
    if (state.conversationSession) {
      state.conversationSession.isInitialState = false;
      state.conversationSession.isPresentationAvatarAllowed = !isOpen;
    }
  },

  UPDATE_EMOTION_TO_PLAY: (state: IConversationSessionState, emotionToPlay: string) => {
    EventBus.$emit('ON_STOP_ANIMATION_EVENT', '' + state.emotionToPlayId);
    state.emotionToPlayId = EmotionIdFromString[emotionToPlay];
  },

  UPDATE_SESSION_SCORE: (state: IConversationSessionState, score: number) => {
    if (state.conversationSession) {
      state.conversationSession.score = score;
    }
  },
};